import e from "react";
import { Navbar as g } from "../../../features/landing/components/Navbar/Navbar.js";
import { mapSharedLandingDesignToNavbar as l } from "./utils.js";
import { SharedLandingBody as c } from "./SharedLandingBody.js";
import { SharedLandingShell as f } from "./SharedLandingShell.js";
import { SharedLandingFooter as h } from "./SharedLandingFooter.js";
function E(t) {
  const {
    design: r,
    backgroundImage: n,
    navbar: a,
    children: m,
    rotative: o,
    buttons: d,
    utmReferral: i
  } = t;
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "shared-landing" }, /* @__PURE__ */ e.createElement(f, { backgroundImage: n, design: r }, /* @__PURE__ */ e.createElement(
    g,
    {
      ...a,
      design: l(r),
      menu: a.menu
    },
    /* @__PURE__ */ e.createElement(
      c,
      {
        design: r,
        rotative: o,
        buttons: d,
        utmReferral: i
      },
      m
    ),
    /* @__PURE__ */ e.createElement(h, { design: r })
  )));
}
export {
  E as SharedLanding
};
//# sourceMappingURL=SharedLanding.js.map
